import { render, staticRenderFns } from "./loader-fullscreen.vue?vue&type=template&id=5ad1794a&"
import script from "./loader-fullscreen.vue?vue&type=script&lang=js&"
export * from "./loader-fullscreen.vue?vue&type=script&lang=js&"
import style0 from "./loader-fullscreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports